import styled from 'styled-components'
import { space } from 'styled-system'

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 250px;
  ${space}
`
